import api from "core/api/api";
import { getParams } from "../../../../../../../../../src/modules/wizards/services";

export default {
    wizardType: "ORACLE",

    getJDBCURL: (m) =>
        "jdbc:oracle:thin:@//" + m.get("host") + ":" + m.get("port") + "/" + m.get("sid"),

    getConnectionParams: async (type, model) => getParams(type, model),

    async fetchTableWrapper(model, agentName, metaObjectFQN, adapterName_version) {
        const sslConfigString = model.get("SSLConfig");
        const params = model.get("encrypted")
            ? {
                  UserName: model.get("username"),
                  Password: { encrypted: model.get("password") },
                  ConnectionURL: model.getJDBCURL(),
                  encrypted: true,
                  ...(sslConfigString && { SSLConfig: sslConfigString })
              }
            : await getParams("ORACLE", model);
        return api.WizardHelper_GetDBs("ORACLE", params, agentName, metaObjectFQN, adapterName_version);
    },
};

